<div class="card travel-box">
    <div class="card_info">
        <div [ngClass]="(isProductSelected()) ? 'corner-selected selected' : 'corner-selected'">
            <div class="input-selector" (click)="selectProduct.emit(product)"></div>
        </div>
        <app-card-header></app-card-header>
        <app-card-body></app-card-body>
    </div>
</div>